import { render, staticRenderFns } from "./SelectScanModal.vue?vue&type=template&id=452c4b30&scoped=true&"
import script from "./SelectScanModal.vue?vue&type=script&lang=js&"
export * from "./SelectScanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c4b30",
  null
  
)

export default component.exports